export default "__VITE_ASSET__6cb046b8__"